module.exports = __webpack_public_path__ + "img/mouth-closed.de3b7b3c.png";